export const useBlackList = () => {
  // 추후 블랙리스트 db 추가해서 불러오는 형태로 변경
  const idBlackList = ["clvju83nwbogvlbt5oatd0z2y"];

  return idBlackList;
};
